import { useTranslations } from '@npco/utils-translations'
import { ModalForm } from '@npco/zeller-design-system'
import { Formik } from 'formik'

import { transferRemittancesModalTranslations } from './TransferRemittancesModal.i18n'
import { ModalContentWrapper } from './TransferRemittancesModal.styled'
import { RemittanceData } from './TransferRemittancesModal.types'

type TransferRemittancesModalProps = {
  isOpen: boolean
  onCancel: () => void
  onSend: () => void
  title: string
  description: string
  children: React.ReactNode
}

export const TransferRemittancesModal = ({
  isOpen,
  onCancel,
  onSend,
  title,
  description,
  children,
}: TransferRemittancesModalProps) => {
  const t = useTranslations(transferRemittancesModalTranslations)
  return (
    <Formik<RemittanceData>
      initialValues={{
        sms: '',
        email: '',
        smsCheckbox: false,
        emailCheckbox: false,
      }}
      onSubmit={onSend}
    >
      <ModalForm
        onClickPrimary={onSend}
        primaryButtonLabel={t('send')}
        secondaryButtonLabel={t('cancel')}
        isOpen={isOpen}
        onCancel={onCancel}
        title={title}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        isLoading={false}
        isPrimaryButtonDisabled={false}
        contentStyle={{
          marginTop: '0',
        }}
        isFullScreen={false}
        showOverflow={false}
        canScroll={false}
        ariaHideApp={false}
      >
        <ModalContentWrapper>
          {description}
          {children}
        </ModalContentWrapper>
      </ModalForm>
    </Formik>
  )
}
